import { Box, Button, Icon, ModuleHeaderContainer } from "@tm/components"
import { Navigation } from "../../Navigation"
import { Areas } from "./Areas"
import { CompilationSettings } from "./CompilationSettings"
import { Options } from "./Options"
import { useFavoriteArticlesStore } from "../store"

type ModuleHeaderProps = {
    onClose?: () => void
    onCloseDetails: () => void
}

export function WmModuleHeader({ onClose, onCloseDetails }: ModuleHeaderProps) {
    const { selectedCompilation } = useFavoriteArticlesStore()

    return (
        <ModuleHeaderContainer>
            <Navigation listType="favorite-articles" />
            <Areas onCloseDetails={onCloseDetails} />
            <Options />
            {!!selectedCompilation && <CompilationSettings selectedCompilation={selectedCompilation} />}
            <Box ml="auto" alignSelf="start">
                {onClose && <Button onClick={onClose} color="primary" startIcon={<Icon name="close" />} />}
            </Box>
        </ModuleHeaderContainer>
    )
}
